"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditInventoryStock = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const filter_bar_1 = require("client/components/filter-bar");
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const switch_1 = require("client/components/material/switch");
const text_field_1 = require("client/components/material/text-field");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const store_1 = require("client/modules/inventory/modules/inventory-list/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const AllInclusive_1 = require("material-ui-icons/AllInclusive");
const Delete_1 = require("material-ui-icons/Delete");
const PriorityHigh_1 = require("material-ui-icons/PriorityHigh");
const Warning_1 = require("material-ui-icons/Warning");
const Collapse_1 = require("material-ui/transitions/Collapse");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const permissions_1 = require("shared/permissions");
const uppercase_string_1 = require("shared/util/uppercase-string");
const throttle_debounce_1 = require("throttle-debounce");
require("./edit-inventory-stock.less");
const columns = [
    {
        label: "ndc",
        id: "package"
    },
    {
        label: "name",
        id: "name"
    },
    {
        label: "pkg qty/form",
        id: "dosage"
    },
    {
        label: "min",
        id: "min"
    },
    {
        label: "max",
        id: "max"
    },
    {
        label: "qty",
        id: "inventorysite.quantity"
    }
];
let EditInventoryStock = class EditInventoryStock extends react_1.Component {
    constructor() {
        super(...arguments);
        this.isFormChanged = false;
        this.showSaveAllConfirmation = false;
        this.showChildren = {};
        this.isCollapse = true;
        this.checkedRowId = -1;
        this.editInventoryId = -1;
        this.currentRowIndex = -1;
        this.order = "ASC";
        this.orderBy = "package";
        this.filterText = "";
        this.autoFocusForm = true;
        this.activeSite = store_2.sitesDetailStore.site.value;
        this.newLot = {
            lotNumber: "",
            expireDate: new Date().toString(),
            quantity: 0
        };
        this.inventoriesLots = new Map();
        this.originalInventoriesLots = new Map();
        this.previousInventoriesLots = new Map();
        this.inventoriesQuantity = new Map();
        this.originalInventoriesQuantity = new Map();
        this.inventoriesLotsEdits = {};
        this.manageLotMode = false;
        this.showInventoryLots = true;
        this.loadInventory = throttle_debounce_1.debounce(200, async () => {
            if (!this.activeSite) {
                return;
            }
            const options = {
                count: 100,
                order: this.order,
                search: this.filterText,
                start: 0,
                where: `inventorysite.siteId = ${this.activeSite.id} AND inventorysite.active = true`,
                sort: this.orderBy
            };
            await store_1.inventoryListStore.loadInventory(options);
            this.initializeInventoryQuantity();
        });
        this.loadInventorySiteLots = throttle_debounce_1.debounce(200, async () => {
            if (!this.activeSite) {
                return;
            }
            const options = {
                count: 100,
                order: "",
                search: "",
                start: 0,
                where: ``,
                sort: "",
                siteId: this.activeSite.id
            };
            await store_1.inventoryListStore.loadInventorySiteLots(options);
            this.initializeInventoryLots();
            this.initializeInventoryQuantity();
        });
        this.initializeInventoryLots = () => {
            // reset this.inventoriesLots before re-initializing.
            this.inventoriesLots.clear();
            const { inventorySiteLots: { value: lots = [] } } = store_1.inventoryListStore;
            for (const lot of lots) {
                const inventoryId = lot.inventorySite.inventoryId;
                if (this.inventoriesLots.has(inventoryId)) {
                    const inventoriesLots = Object.assign({}, this.inventoriesLots.get(inventoryId));
                    inventoriesLots[lot.id] = lot;
                    this.inventoriesLots.set(inventoryId, inventoriesLots);
                }
                else {
                    const inventoriesLots = {};
                    inventoriesLots[lot.id] = lot;
                    this.inventoriesLots.set(inventoryId, inventoriesLots);
                }
            }
            this.originalInventoriesLots = new Map(ramda_1.clone(this.inventoriesLots.entries()));
            this.previousInventoriesLots = new Map(ramda_1.clone(this.inventoriesLots.entries()));
        };
        this.initializeInventoryQuantity = () => {
            const { inventory: { value = [] } } = store_1.inventoryListStore;
            this.inventoriesQuantity.clear();
            for (const group of value) {
                if (group && group.children && group.children.length) {
                    for (const child of group.children) {
                        const inventorySite = child.sites.find(site => site.siteId === this.activeSite.id);
                        if (inventorySite) {
                            const { min, max, quantity } = inventorySite;
                            const minMaxQuantity = {
                                min,
                                max,
                                quantity
                            };
                            this.inventoriesQuantity.set(child.id, minMaxQuantity);
                        }
                    }
                }
            }
            this.originalInventoriesQuantity = new Map(this.inventoriesQuantity);
        };
        this.handleAddLotNumber = (inventory) => async () => {
            const inventoryId = inventory.id;
            const newLotMeta = {
                newLot: Object.assign({}, this.newLot),
                inventoryId,
                siteId: this.activeSite.id
            };
            await store_1.inventoryListStore.addInventorySiteLot(newLotMeta);
            this.resetNewLot();
            await this.loadInventory();
            await this.loadInventorySiteLots();
            ReactTooltip.rebuild();
        };
        this.handleLotRemove = (lot) => async () => {
            await store_1.inventoryListStore.removeInventorySiteLot(lot);
            await this.loadInventory();
            await this.loadInventorySiteLots();
        };
        this.resetNewLot = () => {
            this.newLot.lotNumber = "";
            this.newLot.expireDate = new Date().toString();
            this.newLot.quantity = 0;
        };
        this.renderInventoryStockList = (inventory) => {
            const lots = this.inventoriesLots.get(inventory.id) || [];
            const lotsEntriesArray = Object.entries(lots);
            return lotsEntriesArray.map((lotEntry, index) => {
                const lot = lotEntry[1];
                return this.renderInventoryStock(inventory, lot, index);
            });
        };
        this.handleLotEdit = (field, lot, inventory, index) => (event, value) => {
            const inventoriesLots = this.inventoriesLots.get(inventory.id);
            // Update qty on hand
            if (field === "quantity") {
                const normalizedValue = Number(value) >= 0 ? value : 0;
                const inventoriesLotsPrevious = this.previousInventoriesLots.get(inventory.id);
                const previousLotQty = inventoriesLotsPrevious[lot.id][field];
                inventoriesLotsPrevious[lot.id][field] = normalizedValue;
                this.previousInventoriesLots.set(inventory.id, inventoriesLotsPrevious);
                const currentMinMaxQuantity = this.inventoriesQuantity.get(inventory.id);
                const diffPreviousCurrent = Number(normalizedValue) - Number(previousLotQty);
                const minMaxQuantity = Object.assign({}, currentMinMaxQuantity);
                const updatedQtyOnHand = Number(minMaxQuantity[field]) +
                    parseInt(String(diffPreviousCurrent), 10);
                minMaxQuantity[field] = updatedQtyOnHand >= 0 ? updatedQtyOnHand : 0;
                this.inventoriesQuantity.set(inventory.id, minMaxQuantity);
                inventoriesLots[lot.id][field] = normalizedValue;
                this.inventoriesLots.set(inventory.id, inventoriesLots);
            }
            else if (field === "lotNumber") {
                inventoriesLots[lot.id][field] = value;
                this.inventoriesLots.set(inventory.id, inventoriesLots);
            }
            this.isChanged(inventory);
        };
        this.handleLotExpireDateEdit = (field, lot, inventory, index) => (value) => {
            const formattedDate = this.formatDate(value);
            const inventoriesLots = this.inventoriesLots.get(inventory.id);
            inventoriesLots[lot.id][field] = formattedDate;
            this.inventoriesLots.set(inventory.id, inventoriesLots);
            this.isChanged(inventory);
        };
        this.renderInventoryStock = (inventory, lot, key) => {
            const lotIsExpired = this.isExpiredLot(lot);
            return (React.createElement("div", { key: key, className: "lot-exp-qty__lots--item" },
                React.createElement("div", { className: "row lot-row" },
                    React.createElement(text_field_1.MaterialTextField, { className: "lot-number", label: "Lot #", onChange: this.handleLotEdit("lotNumber", lot, inventory, key), value: this.inventoriesLots.get(inventory.id)[lot.id].lotNumber ||
                            lot.lotNumber ||
                            "" }),
                    React.createElement(date_picker_1.MaterialDatePicker, { missing: lotIsExpired, className: "expire-date", label: "Expiration Date", onChange: this.handleLotExpireDateEdit("expirationDate", lot, inventory, key), value: this.inventoriesLots.get(inventory.id)[lot.id].expirationDate ||
                            lot.expirationDate ||
                            "" }),
                    React.createElement(text_field_1.MaterialTextField, { label: "Qty on hand", onChange: this.handleLotEdit("quantity", lot, inventory, key), required: true, type: "number", numType: "integer", value: this.inventoriesLots.get(inventory.id)[lot.id].quantity ||
                            lot.quantity ||
                            0 }),
                    this.manageLotMode && (React.createElement(material_ui_1.Button, { "data-tip": `Remove lot ${lot.lotNumber}`, className: "delete-lot", "data-for": "warning-icon", onClick: this.handleLotRemove(lot) },
                        React.createElement(Delete_1.default, null))),
                    lotIsExpired && (React.createElement(PriorityHigh_1.default, { className: "priority-high", "data-tip": `Lot ${lot.lotNumber} is expired.`, "data-place": "right", "data-for": "warning-icon", fill: "#eeb20d" })))));
        };
        this.renderSiteInventory = (inventory) => (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "main-stock" },
                React.createElement("div", { className: "sub-main-stock" },
                    React.createElement("div", { className: "site-name" },
                        React.createElement("h3", null, inventory.strengthDescription || inventory.name),
                        React.createElement("h4", null, inventory.package),
                        React.createElement("h5", null,
                            React.createElement("a", { className: "site-name__drug-ref-link", onClick: () => router_1.RouteManager.transitionTo(`/formulary/0/${inventory.id}`) }, "View Details"))),
                    React.createElement("div", { className: "inventorysite-info" },
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { label: "Min", onChange: this.handleChangeInventoryQuantity("min", inventory), required: true, type: "number", numType: "integer", value: this.inventoriesQuantity &&
                                    this.inventoriesQuantity.has(inventory.id)
                                    ? this.inventoriesQuantity.get(inventory.id).min
                                    : 0 }),
                            React.createElement(text_field_1.MaterialTextField, { label: "Max", onChange: this.handleChangeInventoryQuantity("max", inventory), required: true, type: "number", numType: "integer", value: this.inventoriesQuantity &&
                                    this.inventoriesQuantity.has(inventory.id)
                                    ? this.inventoriesQuantity.get(inventory.id).max
                                    : 98 }),
                            React.createElement(text_field_1.MaterialTextField, { label: "quantity", onChange: this.handleChangeInventoryQuantity("quantity", inventory), required: true, type: "number", numType: "integer", value: this.inventoriesQuantity &&
                                    this.inventoriesQuantity.has(inventory.id)
                                    ? this.inventoriesQuantity.get(inventory.id).quantity
                                    : 0 })),
                        React.createElement("div", { className: "inventorysite-info__buttons" },
                            React.createElement(button_1.MaterialButton, { className: "btnCancelRow", onClick: this.handleCancelRow }, "Cancel"),
                            React.createElement(button_1.MaterialButton, { onClick: () => this.handleSaveRow(inventory), className: `button-status-${this.status}`, primary: true }, this.status === ui_1.FormStatus.Saved ? "Saved" : "Save")))),
                React.createElement(Collapse_1.default, { in: this.showInventoryLots },
                    React.createElement("div", { className: "lot-exp-qty__lots" },
                        React.createElement("div", { className: "lot-exp-qty__lots--manage-btn" },
                            React.createElement(switch_1.MaterialSwitch, { label: "Manage add/remove", value: this.manageLotMode.toString(), onChange: () => {
                                    ReactTooltip.rebuild();
                                    this.manageLotMode = !this.manageLotMode;
                                }, checked: this.manageLotMode })),
                        this.renderInventoryStockList(inventory)),
                    this.manageLotMode && (React.createElement("div", { className: "lot-exp-qty lot-exp-qty--add" },
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "lot-number", label: "Lot #", onChange: this.handleNewLotChange("lotNumber"), value: this.newLot.lotNumber }),
                            React.createElement(date_picker_1.MaterialDatePicker, { className: "expire-date", label: "Expiration Date", onChange: this.handleNewLotChangeDate, value: this.newLot.expireDate }),
                            React.createElement(text_field_1.MaterialTextField, { label: "Qty on hand", onChange: this.handleNewLotChange("quantity"), required: true, type: "number", numType: "integer", value: this.newLot.quantity })),
                        React.createElement("div", { className: "add-lot-btn-container" },
                            React.createElement(button_1.MaterialButton, { disabled: !this.newLot.lotNumber ||
                                    !this.newLot.expireDate ||
                                    !this.newLot.quantity, onClick: this.handleAddLotNumber(inventory) }, "Add lot"))))))));
        this.renderChildRowEditMode = (child, index) => (React.createElement("div", { key: -1 }, ((this.checkedRowId === this.editInventoryId &&
            this.editInventoryId === child.id) ||
            (this.editInventoryId === child.id && !this.isCollapse)) && (React.createElement("div", { className: "edit-inventorysite", key: -1 },
            React.createElement("div", { className: "list-component__row" }, this.renderSiteInventory(child))))));
        this.isExpiredLot = (lot) => !lot.expirationDate ||
            moment(lot.expirationDate).isSameOrBefore(moment(new Date()));
        this.renderGroupedListRow = (row, index) => (React.createElement("div", { key: index },
            React.createElement(list_item_1.MaterialListItem, { category: list_item_1.IListItemCategory.GroupHeader, onClick: () => {
                    this.handleClickGroup(index);
                } },
                React.createElement(list_item_text_1.MaterialListItemText, { groupHeader: true, primary: `${row.group || CONFIG.emptyText}` })),
            React.createElement(Collapse_1.default, { in: this.showChildren[index] !== false },
                React.createElement(list_1.MaterialList, { rows: row.children, renderRow: this.renderGroupedListChild }))));
        this.renderGroupedListChild = (child, index) => {
            const className = this.currentRowIndex === index
                ? "list-component__row edit-active"
                : "list-component__row edit-inactive";
            const inventorysite = child.sites &&
                child.sites.find(inventorysite => inventorysite.inventoryId === child.id);
            const minQuantity = inventorysite ? inventorysite.min : 0;
            const maxQuantity = inventorysite ? inventorysite.max : 98;
            const quantity = inventorysite ? inventorysite.quantity : 0;
            let lotsTotal = 0;
            const inventoryLots = this.inventoriesLots.get(child.id) || {};
            for (const lot in inventoryLots) {
                if (inventoryLots.hasOwnProperty(lot)) {
                    const lotQuantity = Number(inventoryLots[lot].quantity);
                    lotsTotal += lotQuantity;
                }
            }
            const quantityMatchLotsQuantity = lotsTotal === quantity;
            const isDev = store_3.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
            const lots = this.inventoriesLots.get(child.id) || [];
            const lotsArray = Object.values(lots);
            const lotsExpired = lotsArray.some(lot => this.isExpiredLot(lot));
            const inventoryName = child.strengthDescription || child.name || child.generic;
            const dosage = child.dosage || "";
            return [
                React.createElement(list_item_1.MaterialListItem, { key: index, className: className, onClick: () => this.handleClickChild(child, index) },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: isDev ? `${child.package} (id: ${child.id})` : child.package }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryName) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(dosage) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: minQuantity }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: maxQuantity }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("div", { className: "warning-quantity" },
                            React.createElement("p", null, quantity),
                            !quantityMatchLotsQuantity ? (React.createElement(Warning_1.default, { className: "warning warning-quantity--icon", "data-tip": `Total lots quantity (${lotsTotal}) does not match inventory quantity (${quantity}).`, "data-place": "right", "data-for": "warning-icon", fill: "#eeb20d" })) : null,
                            lotsExpired ? (React.createElement(PriorityHigh_1.default, { className: "priority-high", "data-tip": `Lot(s) expired.`, "data-place": "right", "data-for": "warning-icon", fill: "#ff7f57" })) : null,
                            inventorysite && inventorysite.backorderExpectedDate ? (React.createElement(AllInclusive_1.default, { className: "backorder-notice", "data-tip": `Backorder expected availability date: 
                  ${moment(inventorysite.backorderExpectedDate).format("MM-DD-YYYY")}`, "data-place": "right", "data-for": "warning-icon", fill: "#2e1cf8" })) : null) })),
                this.renderChildRowEditMode(child, index)
            ];
        };
        this.renderForm = () => (React.createElement(ui_1.UiForm, { buttons: store_3.usersStore.permissions.UpdateLots && [
                React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                "Save"
            ], loading: this.props.loading, isChanged: () => this.isFormChanged, status: this.status, saved: "Saved", 
            // onSubmit={this.handleSaveAll}
            onSubmit: () => (this.showSaveAllConfirmation = true), error: this.props.error },
            React.createElement("div", { className: "inventory__list" }, this.renderGroupedList())));
        this.initialDataLoad = async () => {
            if (!this.activeSite) {
                return;
            }
            const options = {
                count: 100,
                order: this.order,
                search: this.filterText,
                start: 0,
                where: `inventorysite.siteId = ${this.activeSite.id} AND inventorysite.active = true`,
                sort: this.orderBy
            };
            await store_1.inventoryListStore.loadInventory(options);
            this.initializeInventoryQuantity();
            const siteLotsOptions = {
                count: 100,
                order: "",
                search: "",
                start: 0,
                where: ``,
                sort: "",
                siteId: this.activeSite.id
            };
            await store_1.inventoryListStore.loadInventorySiteLots(siteLotsOptions);
            this.initializeInventoryLots();
            this.initializeInventoryQuantity();
        };
        this.handleNewLotChangeDate = (value) => {
            const formattedDate = this.formatDate(value);
            this.newLot.expireDate = formattedDate;
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadInventory();
        };
        this.handleNewLotChange = (field) => (event, value) => {
            switch (field) {
                case "lotNumber":
                    this.newLot[field] = value;
                    break;
                case "quantity":
                    this.newLot[field] = Number(value) >= 0 ? Number(value) : 0;
                    break;
                default:
                    return;
            }
        };
        this.handleChangeInventoryQuantity = (field, inventory) => (event, value) => {
            const currentMinMaxQuantity = this.inventoriesQuantity.get(inventory.id);
            const minMaxQuantity = Object.assign({}, currentMinMaxQuantity);
            minMaxQuantity[field] =
                !Number.isNaN(Number(value)) && Number(value) >= 0
                    ? parseInt(value, 10)
                    : 0;
            this.inventoriesQuantity.set(inventory.id, minMaxQuantity);
            this.isChanged(inventory);
        };
        this.isChanged = (inventory) => {
            // const site = sitesDetailStore.site.value;
            // if (!site) {
            //   return false;
            // }
            const originalInventoryLots = this.originalInventoriesLots.get(inventory.id);
            const originalInventoryQuantity = this.originalInventoriesQuantity.get(inventory.id);
            const inventoryLots = this.inventoriesLots.get(inventory.id);
            const inventoryQuantity = this.inventoriesQuantity.get(inventory.id);
            let resultQuantity;
            let resultLots;
            if (originalInventoryQuantity && inventoryQuantity) {
                resultQuantity = ramda_1.difference([originalInventoryQuantity], [inventoryQuantity]);
            }
            if (originalInventoryLots && inventoryLots) {
                resultLots = ramda_1.difference(Object.entries(originalInventoryLots), Object.entries(inventoryLots));
            }
            if ((resultQuantity && resultQuantity.length > 0) ||
                (resultLots && resultLots.length > 0)) {
                this.status = ui_1.FormStatus.Dirty;
                if (!this.isFormChanged) {
                    this.isFormChanged = true;
                }
                return true;
            }
            this.status = ui_1.FormStatus.Clean;
            return false;
        };
        this.handleCancel = () => {
            this.props.onCancel();
        };
        this.handleClickGroup = (index) => {
            this.showChildren = ramda_1.merge(this.showChildren, {
                [index]: this.showChildren[index] === false ? true : false
            });
        };
        this.handleClickChild = (child, index) => {
            if (this.editInventoryId === child.id) {
                this.isCollapse = !this.isCollapse;
            }
            else {
                this.isCollapse = false;
            }
            if (this.isChanged(child)) {
                this.status = ui_1.FormStatus.Dirty;
            }
            else {
                this.status = ui_1.FormStatus.Clean;
            }
            this.checkedRowId = -1;
            this.editInventoryId = child.id;
            this.currentRowIndex = index;
        };
        this.handleCancelRow = () => {
            this.editInventoryId = -1;
            this.autoFocusForm = true;
        };
        this.handleSaveRow = (inventory) => {
            const inventoryLotFromInventoriesLots = this.inventoriesLots.get(inventory.id);
            this.inventoryMetasToSave = [
                {
                    inventoryLots: inventoryLotFromInventoriesLots
                        ? Object.values(this.inventoriesLots.get(inventory.id))
                        : [],
                    inventoryQuantity: this.inventoriesQuantity.get(inventory.id),
                    inventoryId: inventory.id
                }
            ];
            this.handleSubmit();
        };
        this.handleSaveAll = () => {
            const inventoryMetas = [];
            for (const [inventoryId] of this.inventoriesQuantity) {
                const inventoryLotFromInventoriesLots = this.inventoriesLots.get(inventoryId);
                const inventoryMetaToSave = {
                    inventoryLots: inventoryLotFromInventoriesLots
                        ? Object.values(this.inventoriesLots.get(inventoryId))
                        : [],
                    inventoryQuantity: this.inventoriesQuantity.get(inventoryId),
                    inventoryId
                };
                inventoryMetas.push(inventoryMetaToSave);
            }
            this.inventoryMetasToSave = inventoryMetas;
            try {
                this.handleSubmit();
            }
            catch (err) {
                console.error("Error in saving all inventory lot edits", err);
            }
            finally {
                this.showSaveAllConfirmation = false;
            }
        };
        this.onCallback = (value) => {
            this.autoFocusForm = false;
            this.filterText = value;
            this.loadInventory();
        };
        this.handleSubmit = () => {
            callable_1.callable(this.props.onSave)(this.activeSite, this.inventoryMetasToSave);
            this.loadInventory();
            this.status = ui_1.FormStatus.Clean;
        };
    }
    // public componentWillMount() {
    //   if (this.activeSite) {
    //     this.loadInventory();
    //     this.loadInventorySiteLots();
    //   }
    // }
    async componentDidMount() {
        // if (this.activeSite) {
        // await this.loadInventory();
        // await this.loadInventorySiteLots();
        // }
        await this.initialDataLoad();
    }
    componentWillReceiveProps(props) {
        this.activeSite = store_2.sitesDetailStore.site.value;
        this.loadInventory();
        this.loadInventorySiteLots();
        this.status = this.props.status || ui_1.FormStatus.Clean;
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    renderGroupedList() {
        const { inventory: { value = [] } } = store_1.inventoryListStore;
        return (React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: value, renderRow: this.renderGroupedListRow, resizableheader: true, customClass: "custom-material-list__inventory-stock-list" }));
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(ReactTooltip, { id: "warning-icon", className: "tooltip", effect: "solid", place: "left", "data-type": "warning", multiline: true }),
            React.createElement("div", { className: "site-edit-inventory" }, store_3.usersStore.permissions.ReadLots ? (React.createElement(React.Fragment, null,
                this.renderFilter(),
                this.renderForm())) : (store_3.usersStore.showLock())),
            this.showSaveAllConfirmation && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Save all", cancelText: "Cancel", message: `Confirm to save all edits.`, onCancel: () => {
                    this.showSaveAllConfirmation = false;
                }, onConfirm: this.handleSaveAll, title: "Save all confirmation" }))));
    }
    renderFilter() {
        return (React.createElement("div", { className: "inventory__filter" },
            React.createElement(filter_bar_1.FilterBar, { callBack: this.onCallback, filterText: this.filterText })));
    }
    formatDate(date) {
        const currentDate = new Date(date);
        let month = String(currentDate.getMonth() + 1);
        let day = String(currentDate.getDate());
        const year = currentDate.getFullYear();
        if (month.length < 2) {
            month = "0" + month;
        }
        if (day.length < 2) {
            day = "0" + day;
        }
        return [year, month, day].join("-");
    }
};
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "isFormChanged", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "showSaveAllConfirmation", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "showChildren", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "checkedRowId", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "editInventoryId", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "autoFocusForm", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "activeSite", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "newLot", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "inventoriesLots", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "originalInventoriesLots", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "previousInventoriesLots", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "inventoriesQuantity", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "originalInventoriesQuantity", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "inventoriesLotsEdits", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "manageLotMode", void 0);
__decorate([
    mobx_1.observable
], EditInventoryStock.prototype, "showInventoryLots", void 0);
EditInventoryStock = __decorate([
    mobx_react_1.observer
], EditInventoryStock);
exports.EditInventoryStock = EditInventoryStock;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/components/edit-inventory-stock/edit-inventory-stock.tsx
// module id = 4119
// module chunks = 0